(function(){
  'use strict';
  if(window.__SSQBlasterOfferV1)return;
  window.__SSQBlasterOfferV1=true;

  function closeMenus(root){
    root.querySelectorAll('[data-ssqbb-menu]').forEach(function(menu){menu.hidden=true;});
    root.querySelectorAll('[data-ssqbb-color]').forEach(function(button){button.setAttribute('aria-expanded','false');});
  }

  function placeMenu(button,menu){
    var rect=button.getBoundingClientRect();
    var width=Math.max(190,rect.width);
    var maxLeft=Math.max(8,window.innerWidth-width-8);
    var left=Math.min(Math.max(8,rect.left),maxLeft);
    menu.style.width=width+'px';
    menu.style.left=left+'px';
    menu.hidden=false;
    var height=Math.min(menu.scrollHeight,Math.max(160,window.innerHeight-24));
    var below=window.innerHeight-rect.bottom-10;
    var above=rect.top-10;
    menu.style.top=(below>=Math.min(height,300)?rect.bottom+7:Math.max(8,rect.top-Math.min(height,above)-7))+'px';
  }

  function init(root){
    if(root.dataset.ssqbbReady==='true')return;
    root.dataset.ssqbbReady='true';
    var bars=Array.prototype.slice.call(root.querySelectorAll('[data-ssqbb-bar]'));
    var submit=root.querySelector('[data-ssqbb-submit]');
    var form=root.querySelector('[data-ssqbb-form]');
    var error=root.querySelector('[data-ssqbb-error]');
    var activeIndex=Number(root.dataset.defaultTier||1);
    var locked=false;

    function selectTier(index){
      activeIndex=index;
      closeMenus(root);
      bars.forEach(function(bar,i){
        var selected=i===index;
        bar.classList.toggle('ssqbb-bar--selected',selected);
        var head=bar.querySelector('[data-ssqbb-tier]');
        var expand=bar.querySelector('[data-ssqbb-expand]');
        if(head)head.setAttribute('aria-checked',selected?'true':'false');
        if(expand)expand.hidden=!selected;
      });
      submit.textContent=bars[index].dataset.cta;
      if(error)error.hidden=true;
    }

    bars.forEach(function(bar,index){
      var head=bar.querySelector('[data-ssqbb-tier]');
      if(head)head.addEventListener('click',function(){selectTier(index);});
    });

    root.addEventListener('click',function(event){
      var colorButton=event.target.closest('[data-ssqbb-color]');
      if(colorButton&&root.contains(colorButton)){
        event.preventDefault();
        var slot=colorButton.closest('[data-ssqbb-slot]');
        var menu=slot&&slot.querySelector('[data-ssqbb-menu]');
        if(!menu)return;
        var opening=menu.hidden;
        closeMenus(root);
        if(opening){
          placeMenu(colorButton,menu);
          colorButton.setAttribute('aria-expanded','true');
        }
        return;
      }

      var option=event.target.closest('[data-ssqbb-option]');
      if(option&&root.contains(option)){
        event.preventDefault();
        var slot=option.closest('[data-ssqbb-slot]');
        var label=slot.querySelector('[data-ssqbb-chip-label]');
        var dot=slot.querySelector('[data-ssqbb-chip-dot]');
        var image=slot.querySelector('[data-ssqbb-slot-image]');
        slot.dataset.variantId=option.dataset.variantId;
        if(label)label.textContent=option.dataset.variantTitle;
        if(dot)dot.style.setProperty('--ssqbb-dot',option.dataset.variantColor);
        if(image)image.src=option.dataset.variantImage;
        slot.querySelectorAll('[data-ssqbb-option]').forEach(function(item){
          var selected=item===option;
          item.classList.toggle('ssqbb-pop-item--selected',selected);
          item.setAttribute('aria-selected',selected?'true':'false');
        });
        closeMenus(root);
      }
    });

    document.addEventListener('click',function(event){if(!root.contains(event.target))closeMenus(root);});
    window.addEventListener('resize',function(){closeMenus(root);},{passive:true});
    window.addEventListener('scroll',function(){closeMenus(root);},{passive:true});

    form.addEventListener('submit',function(event){
      event.preventDefault();
      if(locked)return;
      var active=bars[activeIndex];
      var counts={};
      active.querySelectorAll('[data-ssqbb-slot]').forEach(function(slot){
        var id=String(slot.dataset.variantId||'');
        if(id)counts[id]=(counts[id]||0)+1;
      });
      var items=Object.keys(counts).map(function(id){return{id:Number(id),quantity:counts[id]};});
      var selectedCount=items.reduce(function(total,item){return total+item.quantity;},0);
      if(selectedCount!==Number(active.dataset.count)){
        error.hidden=false;
        error.textContent='Choose a color for every figure.';
        return;
      }
      locked=true;
      submit.disabled=true;
      submit.textContent='ADDING…';
      error.hidden=true;
      var rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(rootPath+'cart/add.js?kaching_bundles=true',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})
      }).then(function(response){
        if(!response.ok)return response.json().catch(function(){return{};}).then(function(detail){throw new Error(detail.description||detail.message||'cart add failed');});
        return response.json();
      }).then(function(){
        submit.textContent='ADDED ✓';
        window.location.assign(rootPath+'checkout');
      }).catch(function(){
        locked=false;
        submit.disabled=false;
        submit.textContent=active.dataset.cta;
        error.hidden=false;
        error.textContent='We could not add your StickSquad yet. Check your colors and try again.';
      });
    });

    selectTier(activeIndex);
  }

  function boot(){document.querySelectorAll('[data-ssqbb]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  window.addEventListener('load',boot,{once:true});
})();
